import { get, post, api_request } from './core'

/**
 * Async login
 * @description Returns object with `token`
 * @param {FormData} data FormData
 * @param {string} data.email
 * @param {string} data.password
 * @return {Promise.<*>}
 */
export function login (data) {
  return post('/api/login', data)
}

/**
 * Async register
 * @description Returns object with `token`
 * @param {FormData} data FormData
 * @param {string} data.email
 * @param {string} data.password
 * @param {string} data.city
 * @param {string} data.job
 * @param {string} data.surname
 * @param {string} data.prename Name
 * @param {string} data.gender Char: `m` or `f`
 * @param {number} data.birthdate ISO 8601 date without milliseconds
 * @return {Promise.<*>}
 */
export function register (data) {
  return post('/api/register', data)
}

/**
 * Async update user
 * @description Returns object with `token`
 * @param {FormData|Object} data FormData
 * @param {string} data.email
 * @param {string} data.password
 * @param {string} data.city
 * @param {string} data.job
 * @param {string} data.surname
 * @param {string} data.prename Name
 * @param {string} data.gender Char: `m` or `f`
 * @param {number} data.birthdate ISO 8601 date without milliseconds
 * @param {string} data.description
 * @param {string} token
 * @return {Promise.<*>}
 */
export function update (data, token) {
  return api_request('/api/users', data, {
    method: 'PATCH',
    token
  })
}

/**
 * Get current user
 * @param {string} token
 * @return {Promise<boolean>}
 */
export function me (token) {
  return get('/api/me', token)
}

/**
 * Get current user notifications
 * @param {string} token
 * @return {Promise<boolean>}
 */
export function notifications (token) {
  return get('/api/me/notifications', token)
}

/**
 * Async forgotPassword
 * @description Returns object with `token`
 * @param {FormData} data FormData
 * @param {string} data.email
 * @return {Promise.<*>}
 */
export function forgotPassword (data) {
  let addedData = {url: window.location.origin + '/ResetPassword?'}
  return post('/api/password/email', data, {addedData})
}

/**
 * Async resetPassword
 * @description Returns object with `token`
 * @param {FormData} data FormData
 * @param {string} data.email
 * @param {string} data.password New password
 * @param {Object} addedData
 * @param {string} addedData.token Token to reset password
 * @return {Promise.<*>}
 */
export function resetPassword (data, addedData) {
  return post('/api/password/reset', data, addedData)
}

/**
 * Async get categories
 * @return {Promise<boolean>}
 */
export function categories () {
  return get('/api/categories')
}

/**
 * Async get user by ID
 * @param {string} id
 * @param {string} token
 * @return {Promise<boolean>}
 */
export function user_by_id (id, token) {
  return get('/api/users/' + id, token)
}

/**
 * Async update user image
 * @param {FormData} data FormData
 * @param {Object} data.image FormData image
 * @param {string} token
 * @return {Promise<*>}
 */
export function update_user_image (data, token) {
  return post('/api/users/image/', data, {
    token,
    contentType: 'multipart/form-data', // Disable JSON stringified body
    contentTypeDisabled: true // Disable Content-Type header
  })
}

/**
 * Async get experience
 * @param {string|number} id
 * @return {Promise<boolean>}
 */
export function experience (id) {
  return get('/api/experiences/' + id)
}

/**
 * Async create experience
 * @param {FormData} data FormData
 * @param {string} token
 * @param {Object} addedData
 * @return {Promise<*>}
 */
export function create_experience (data, token, addedData) {
  return post('/api/experiences/', data, {
    token,
    addedData
  })
}

/**
 * Async update experience image
 * @param {FormData} data FormData
 * @param {Object} data.image FormData image
 * @param {string} token
 * @param {string|number} experience_id
 * @return {Promise<*>}
 */
export function update_experience_image (data, token, experience_id) {
  return post('/api/experiences/image/' + experience_id, data, {
    token,
    contentType: 'multipart/form-data', // Disable JSON stringified body
    contentTypeDisabled: true // Disable Content-Type header
  })
}

/**
 * Async get cities
 * @param {string} token
 * @return {Promise<boolean>}
 */
export function cities (token) {
  return get('/api/cities', token)
}

/**
 * Async get payment methods
 * @param {string} token
 * @return {Promise<boolean>}
 */
export function payment_methods (token) {
  return get('/api/paymentmethods', token)
}

export default {
  login,
  register,
  me,
  notifications,
  forgotPassword,
  resetPassword,
  categories,
  experience,
  create_experience,
  update_experience_image,
  cities,
  payment_methods
}



// WEBPACK FOOTER //
// ./src/api/index.js